import {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {navigationTree, selectTree, urlProject} from "../actions/proyects.actions";
import {SelectedDateFn} from '../actions/auth.action';
import {alpha, makeStyles, withStyles} from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import {useHistory} from "react-router-dom";
import subprojectIcon from "../assets/img/icons/subproject.png";
import projectIcon from "../assets/img/icons/project.png";

// import { useSpring, animated } from 'react-spring/web.cjs'; // web.cjs is required for IE 11 support
import {useSelector, useDispatch} from "react-redux";

function MinusSquare(props) {
	return (
		<div className="d-flex" {...props}>
			<ion-icon name="chevron-down-outline"></ion-icon>
			<img
				src={projectIcon}
				alt="icons"
				width="15"
				style={{marginRight: 8}}
			/>
		</div>
	);
}

function PlusSquare(props) {
	return (
		<div className="d-flex" {...props}>
			<ion-icon name="chevron-forward-outline"></ion-icon>
			<img
				src={projectIcon}
				alt="icons"
				width="15"
				style={{marginRight: 8}}
				{...props}
			/>
		</div>
	);
}

function CloseSquare(props) {
	return (
		<img
			src={subprojectIcon}
			width="15"
			alt="icons"
			style={{marginRight: 8}}
			{...props}
		/>
	);
}

const StyledTreeItem = withStyles((theme) => ({
	iconContainer: {
		"& .close": {
			opacity: 0.3,
		},
	},
	group: {
		marginLeft: 7,
		paddingLeft: 18,
		borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
	},
}))((props) => <TreeItem {...props} />);

const useStyles = makeStyles({
	root: {
		height: 264,
		flexGrow: 1,
		maxWidth: 400,
	},
});

const Tree = ({data, nodeSelected, urlPrefix, idName = 'CodProyecto', resetDate=true, onSelectItem}) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	let history = useHistory();

	const [levelStart] = useState(1);
	const [loading, setLoading] = useState(true);
	const proyects = useSelector((state) => state.proyects);
	const [refreshTree, setRefreshTree] = useState(null);
	
	const [treeData, setTreeData] = useState([])
	const [search, setSearch] = useState()
	const [searchRegex, setSearchRegex] = useState()


	
	const converTreeArrayToMap = (treeArray) => {
		let orderedLevels = {};
		
		for (let i = 0; i < treeArray.length; i++) {
			const item = treeArray[i];
			// if (item.Nivel >= levelStart) {
				if (!orderedLevels[item.Nivel]) {
					orderedLevels[item.Nivel] = [];
				}
				// if (item.Nivel > lastLevel) {
				// 	setLastLevel(item.Nivel);
				// }
				if (nodeSelected && nodeSelected.startsWith(item[idName])) {
					dispatch(selectTree(item[idName], true));
				}
				orderedLevels[item.Nivel].push({
					searchMatch: false,
					hidden: false,
					...item,
				});
			// }
		}
	
		return orderedLevels;

	}

	// toma el diccionario y lo ordena usando el nivel como referencia
	
	const orderAllElements = (level = 1, parent = null, treeMap = null) => {
		if( (!treeMap || !treeMap[level]) ) {
			
			return null;
		};
		const nextLevel = level + 1;
		return treeMap[level]
				.filter(
					(item) =>
						parent === null || item.PhantomParentId === parent[idName]
				)
				.map((filter) => {
					filter['breadcrumbs'] = level > 1 ? `${parent.breadcrumbs ? parent.breadcrumbs + ' / ' : '' }${filter.Descripcion}` : '';
					// filter['prevParents'] = parent ? [...parent.prevParents, filter[idName]] : [filter[idName]];
					filter.changeParent = parent 
						? () =>{ 
							filter.hidden = false;
							parent.changeParent();
							// TODO: aqui agregar para que se abra, en nuestro redux de selecteds
						} 
						: () => {
							filter.hidden = false;
						};
					if ( level === 1 || !search || search === '' ) {
						filter['hidden'] = false;
					} else {
						const descriptionLower = filter.Descripcion.toLowerCase();
						filter.searchMatch = new RegExp(search.toLowerCase()).test(descriptionLower) // descriptionLower.includes(search.toLowerCase());
						if (filter.searchMatch || (searchRegex !== '' && descriptionLower.match(searchRegex))) {
							
							filter.changeParent();
						} else if ( parent && parent.searchMatch ) {
							filter.hidden = false;
						} else {
							filter['hidden'] = true;
						}
					}
					filter['items'] = orderAllElements(nextLevel, filter, treeMap);
					return filter;
				});
	}

	
	useEffect(() => {
	
		if ( search && search.includes(' ') ) {
			const myRegex = `(?=.*${search.toLowerCase().replaceAll(' ', ')(?=.*')})`;
			setSearchRegex(new RegExp(myRegex));
			setSearchRegex(myRegex);
		} else {
			setSearchRegex('');	
		}
		const treeMap = converTreeArrayToMap( data );
		const anyThing = orderAllElements(1, null, treeMap);
		setTreeData(anyThing);
		setLoading(false);
		// eslint-disable-next-line
	}, [loading, data, search]);

	const selectProject = (item) => {
		if( !item[idName] ) return;
		if(onSelectItem) onSelectItem(item);
		dispatch(urlProject(`${urlPrefix}${item[idName]}`));
		dispatch(SelectedDateFn(''));
		
		if (
			nodeSelected !== item[idName]
		) {
			if(resetDate) localStorage.setItem('date-project', '');
			// dispatch(cleanTreeChilds());
			// llamar CP FT DE
			localStorage.setItem('header-project', item['Descripcion']);
			dispatch(
				navigationTree(
					`${item['Descripcion']}`
				)
			);
			return history.push(`${urlPrefix}${item[idName]}`);
		}
	}

	const drawerItems2 = (level = 1, items) => {
		if ( !items ){ 
			return '';
		}
		return items.map((item) => {
			if (
				nodeSelected &&
				refreshTree === null &&
				nodeSelected ===
				item[idName]
			) {
			
				setRefreshTree(true);
				dispatch(
					navigationTree(
						`${item.breadcrumbs} / ${item.Descripcion}`
					)
				);
			}
			return (
				<StyledTreeItem
					nodeId={item[idName] || item[idName]}
					label={item.Descripcion}
					key={item[idName] || item[idName]}
					hidden={ item.hidden}
					onIconClick={() => {
						dispatch(selectTree(item[idName]));
					}}
					onLabelClick={() => selectProject(item)}
				>
					{ drawerItems2(( level + 1 ), item.items)}
				</StyledTreeItem>
			);
		});

	}



	return (
		<>
			<div className="input-group mb-2">
				<div className="input-group-prepend">
					<div className="input-group-text" id="btnGroupAddon">
						<i className="fas fa-search"></i>
					</div>
				</div>
				<input
					type="search"
					className="form-control"
					placeholder="Buscador..."
					aria-label="Input group example"
					aria-describedby="btnGroupAddon"
					onChange={({target}) => setSearch(target.value)}
				/>
			</div>
			<TreeView
				className={classes.root}
				defaultExpanded={["1"]}
				defaultCollapseIcon={<MinusSquare />}
				defaultExpandIcon={<PlusSquare />}
				defaultEndIcon={<CloseSquare />}
				expanded={proyects.treeSelecteds}
				// className="mb-5"
				selected={nodeSelected}
			>
				{loading ? "Cargando..." : drawerItems2(levelStart, treeData)}
				{/* {loading ? "Cargando..." : drawerItems(1)} */}
			</TreeView>
		</>
	);
};

Tree.propTypes = {
	levelStart: PropTypes.number,
};

export default Tree;
